import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';
import { API_URL } from '../config/api';
import SEO from '../components/SEO';

// interface LoginFormData {
//   email: string;
//   password: string;
// }

export default function LoginPage() {
  // const [formData, setFormData] = useState<LoginFormData>({
  //   email: '',
  //   password: '',
  // });
  const [error, setError] = useState('');
  // const [_, setShowEmailSent] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const returnTo = (location.state as { returnTo?: string } | null)?.returnTo ?? '/api-request?demo=true';

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   if (!formData.email || !formData.password) {
  //     setError('Please fill in all fields');
  //     return;
  //   }
  //   setError('');
  //   try {
  //     // Send email with confirmation link
  //     const response = await fetch(`${API_URL}/auth/send-confirmation-email`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         email: formData.email,
  //         password: formData.password,
  //       }),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       setShowEmailSent(true);
  //     } else {
  //       setError(data.message || 'Failed to send confirmation email');
  //     }
  //   } catch (error) {
  //     setError('Network error. Please try again.');
  //     console.error('Error:', error);
  //   }
  // };


  const handleGoogleLoginSuccess = async (tokenResponse: any) => {
    try {
      // Отправляем токен на бэкенд для верификации и получения JWT
      const response = await fetch(`${API_URL}/auth/google`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_token: tokenResponse.access_token,
        }),
      });

      const data = await response.json();
      if (response.ok && data.access_token) {
        try {
          login(data.access_token, data.apiKey);
          navigate(returnTo);
        } catch (error: any) {
          setError(error.message || 'Failed to log in: API key is missing');
        }
      } else {
        setError(data.message || 'Google login failed');
      }
    } catch (error) {
      setError('Network error. Please try again.');
      console.error('Error:', error);
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: handleGoogleLoginSuccess,
    onError: () => {
      setError('Google login failed. Please try again.');
    },
  });

  const handleGoogleLogin = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    googleLogin();
  };

  const containerStyles = {
    minHeight: '100vh',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column' as const,
  };

  const contentStyles = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    padding: '40px 20px',
  };

  const formContainerStyles = {
    width: '100%',
    maxWidth: '400px',
  };

  const titleStyles = {
    fontSize: '32px',
    fontWeight: 700,
    color: '#000',
    marginBottom: '32px',
    textAlign: 'center' as const,
  };

  const buttonStyles = {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    backgroundColor: '#fff',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    gap: '12px',
    marginBottom: '12px',
  };

  const googleButtonStyles = {
    ...buttonStyles,
    border: '1px solid #e0e0e0',
  };

  const termsStyles = {
    fontSize: '12px',
    color: '#666',
    textAlign: 'center' as const,
    lineHeight: '1.5',
  };

  const termsLinkStyles = {
    color: '#666',
    textDecoration: 'underline' as const,
  };

  const errorStyles = {
    color: '#CF2C20',
    fontSize: '14px',
    marginBottom: '16px',
    textAlign: 'center' as const,
  };

  const GoogleIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M19.6 10.2273C19.6 9.51818 19.5364 8.83636 19.4182 8.18182H10V12.05H15.3818C15.15 13.3 14.4455 14.3591 13.3864 15.0682V17.5773H16.6182C18.5091 15.8364 19.6 13.2727 19.6 10.2273Z" fill="#4285F4"/>
      <path d="M10 20C12.7 20 14.9636 19.1045 16.6182 17.5773L13.3864 15.0682C12.4909 15.6682 11.3455 16.0227 10 16.0227C7.39545 16.0227 5.19091 14.2636 4.40455 11.9H1.06364V14.4909C2.70909 17.7591 6.09091 20 10 20Z" fill="#34A853"/>
      <path d="M4.40455 11.9C4.20455 11.3 4.09091 10.6591 4.09091 10C4.09091 9.34091 4.20455 8.7 4.40455 8.1V5.50909H1.06364C0.386364 6.85909 0 8.38636 0 10C0 11.6136 0.386364 13.1409 1.06364 14.4909L4.40455 11.9Z" fill="#FBBC05"/>
      <path d="M10 3.97727C11.4682 3.97727 12.7864 4.48182 13.8227 5.47273L16.6909 2.60455C14.9591 0.990909 12.6955 0 10 0C6.09091 0 2.70909 2.24091 1.06364 5.50909L4.40455 8.1C5.19091 5.73636 7.39545 3.97727 10 3.97727Z" fill="#EA4335"/>
    </svg>
  );

  return (
    <div style={containerStyles}>
      <SEO 
        title="Sign In — Supaserver"
        noindex={true}
      />
      <div style={contentStyles}>
        <div style={formContainerStyles}>
          <h1 style={titleStyles}>Welcome back</h1>
          
          <button
            type="button"
            onClick={handleGoogleLogin}
            style={googleButtonStyles}
          >
            <GoogleIcon />
            <span>Continue with Google</span>
          </button>

          {/* Email/Password login - temporarily disabled
          <div style={dividerStyles}>
            <div style={dividerLineStyles}></div>
            <span style={dividerTextStyles}>or</span>
            <div style={dividerLineStyles}></div>
          </div>

          {showEmailSent ? (
            <div style={{
              backgroundColor: '#fff',
              borderRadius: '8px',
              padding: '24px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              width: '100%',
              maxWidth: '500px',
              margin: '0 auto',
            }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px' }}>
                <div style={{
                  width: '24px',
                  height: '24px',
                  backgroundColor: '#000',
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '12px',
                  flexShrink: 0,
                }}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div style={{ flex: 1 }}>
                  <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#000', marginBottom: '8px' }}>
                    Check your email to confirm
                  </h2>
                  <p style={{ fontSize: '14px', color: '#000', lineHeight: '1.5', marginBottom: '16px' }}>
                    You've successfully signed in. Please check your email to confirm your account before accessing the dashboard. The confirmation link expires in 10 minutes.
                  </p>
                  <p style={{ fontSize: '14px', color: '#000' }}>
                    Have an account? <Link to="/login" style={{ textDecoration: 'underline', color: '#000' }}>Sign In Now</Link>
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <>
              {error && <div style={errorStyles}>{error}</div>}
              <form onSubmit={handleSubmit} autoComplete="on">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email address"
                  style={inputStyles}
                  autoComplete="username"
                  required
                />
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  style={inputStyles}
                  autoComplete="current-password"
                  required
                />
                <button type="submit" style={continueButtonStyles}>
                  Continue
                </button>
              </form>
            </>
          )}
          */}
          
          {error && <div style={errorStyles}>{error}</div>}

          <p style={termsStyles}>
            By continuing, you agree to Supaserver's{' '}
            <Link to="/terms" style={termsLinkStyles}>Terms of Service</Link>
            {' '}and{' '}
            <Link to="/privacy" style={termsLinkStyles}>Privacy Policy</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}

// 955776702142-4snoes65g76p6p17m7b64jj4dehcg3te.apps.googleusercontent.com